import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, Transition as _Transition } from "vue";
const _hoisted_1 = {
  class: "grid grid-cols-1 md:grid-cols-4 gap-4 mb-3"
};
const _hoisted_2 = {
  class: "group bg-white rounded-xl border border-slate-200 p-3 hover:shadow-lg hover:border-primary-200 transition-all duration-300 cursor-pointer"
};
const _hoisted_3 = {
  class: "text-xl font-bold text-slate-900 mb-1"
};
const _hoisted_4 = {
  class: "group bg-white rounded-xl border border-slate-200 p-3 hover:shadow-lg hover:border-green-200 transition-all duration-300 cursor-pointer"
};
const _hoisted_5 = {
  class: "text-xl font-bold text-green-600 mb-1"
};
const _hoisted_6 = {
  class: "group bg-white rounded-xl border border-slate-200 p-3 hover:shadow-lg hover:border-amber-200 transition-all duration-300 cursor-pointer"
};
const _hoisted_7 = {
  class: "text-xl font-bold text-amber-600 mb-1"
};
const _hoisted_8 = {
  class: "group bg-white rounded-xl border border-slate-200 p-3 hover:shadow-lg hover:border-red-200 transition-all duration-300 cursor-pointer"
};
const _hoisted_9 = {
  class: "text-xl font-bold text-red-600 mb-1"
};
const _hoisted_10 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_11 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_12 = {
  class: "filter-bar-field"
};
const _hoisted_13 = {
  class: "filter-bar-field"
};
const _hoisted_14 = {
  class: "filter-bar-field"
};
const _hoisted_15 = {
  class: "data-table-shell"
};
const _hoisted_16 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_17 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  class: "data-table-td"
};
const _hoisted_20 = {
  class: "flex items-center gap-3"
};
const _hoisted_21 = {
  class: "font-semibold text-slate-900"
};
const _hoisted_22 = {
  class: "text-xs text-slate-400 flex items-center gap-2"
};
const _hoisted_23 = {
  key: 0,
  class: "text-slate-300"
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  class: "data-table-td"
};
const _hoisted_26 = {
  class: "flex flex-col"
};
const _hoisted_27 = {
  class: "text-sm font-medium text-slate-700"
};
const _hoisted_28 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_29 = {
  class: "data-table-td"
};
const _hoisted_30 = {
  class: "flex flex-col"
};
const _hoisted_31 = {
  class: "text-sm font-medium text-slate-700"
};
const _hoisted_32 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_33 = {
  class: "data-table-td"
};
const _hoisted_34 = {
  class: "data-table-td is-right font-semibold text-slate-700"
};
const _hoisted_35 = {
  class: "data-table-td is-right font-bold text-slate-900"
};
const _hoisted_36 = {
  class: "data-table-td is-center"
};
const _hoisted_37 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_38 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_39 = ["onClick"];
const _hoisted_40 = ["onClick"];
const _hoisted_41 = ["onClick"];
const _hoisted_42 = ["onClick"];
const _hoisted_43 = ["onClick"];
const _hoisted_44 = {
  key: 0,
  class: "py-16 text-center"
};
const _hoisted_45 = {
  class: "flex items-center justify-between px-6 py-4 bg-gradient-to-r from-slate-50 to-white border-b border-slate-100"
};
const _hoisted_46 = {
  class: "flex items-center gap-3"
};
const _hoisted_47 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_48 = {
  class: "text-xs text-slate-500"
};
const _hoisted_49 = {
  class: "overflow-y-auto max-h-[calc(90vh-140px)]"
};
const _hoisted_50 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-5 p-6"
};
const _hoisted_51 = {
  class: "group"
};
const _hoisted_52 = {
  class: "group"
};
const _hoisted_53 = {
  class: "group"
};
const _hoisted_54 = {
  class: "group"
};
const _hoisted_55 = {
  class: "group"
};
const _hoisted_56 = {
  class: "group"
};
const _hoisted_57 = {
  class: "group"
};
const _hoisted_58 = {
  class: "group"
};
const _hoisted_59 = {
  class: "group"
};
const _hoisted_60 = {
  class: "group"
};
const _hoisted_61 = {
  class: "group"
};
const _hoisted_62 = {
  class: "md:col-span-2 group"
};
const _hoisted_63 = {
  class: "md:col-span-2 group"
};
const _hoisted_64 = {
  class: "border border-slate-200 rounded-lg p-4 bg-slate-50"
};
const _hoisted_65 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_66 = {
  class: "text-sm text-slate-600"
};
const _hoisted_67 = {
  class: "font-semibold text-primary-600"
};
const _hoisted_68 = {
  key: 0,
  class: "flex flex-wrap gap-2"
};
const _hoisted_69 = {
  class: "text-xs text-slate-500 px-2 py-1 bg-white border border-slate-200 rounded"
};
const _hoisted_70 = {
  key: 1,
  class: "text-sm text-slate-400"
};
const _hoisted_71 = {
  class: "px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3"
};
const _hoisted_72 = ["disabled"];
const _hoisted_73 = {
  key: 0,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
};
const _hoisted_74 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
import { ref, reactive, computed, onMounted } from 'vue';
import { ElMessage, ElMessageBox, ElSelect, ElOption, ElCascader } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
import { buildChinaAreaOptions, chinaAreaData, closeChinaAreaCascaderAfterDistrict, codeTextMap, provinceData } from '@/utils/chinaAreaOptions.mjs';
import { getFranchiseePage, getFranchisee, createFranchisee, updateFranchisee, deleteFranchisee, changeFranchiseeStatus } from '@/api';
import { getProductTree } from '@/api/product';
import FranchiseeDetailModal from './components/FranchiseeDetailModal.vue';
import PlatformLakalaReceiverFormModal from './components/PlatformLakalaReceiverFormModal.vue';
import ProductSelector from './components/ProductSelector.vue';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';

// 地区配置

export default {
  __name: 'FranchiseeManagement',
  setup(__props) {
    const CodeToText = codeTextMap;
    const regions = ['华东', '华北', '华南', '华中', '西南', '西北', '东北'];

    // 状态选项
    const statusOptions = [{
      value: 0,
      label: '潜在加盟商'
    }, {
      value: 1,
      label: '意向加盟商'
    }, {
      value: 2,
      label: '签约审核中'
    }, {
      value: 3,
      label: '正式加盟商'
    }, {
      value: 4,
      label: '暂停'
    }, {
      value: 5,
      label: '终止'
    }];

    // 将扁平的地区数据转换为树形结构（用于级联选择器）
    const regionTree = computed(() => buildChinaAreaOptions());

    // 加载状态
    const loading = ref(false);
    const submitting = ref(false);

    // 加盟商列表
    const franchisees = ref([]);
    const selectedFranchisee = ref(null);

    // 统计
    const stats = reactive({
      total: 0,
      active: 0,
      pending: 0,
      suspended: 0
    });

    // 搜索表单
    const searchForm = reactive({
      name: '',
      statuses: [],
      levels: [],
      majorRegion: '',
      needPerformance: true
    });

    // 分页
    const pagination = reactive({
      current: 1,
      size: 10,
      total: 0,
      pages: 0,
      hasNext: false,
      hasPrevious: false
    });

    // 表单弹窗
    const showFormModal = ref(false);
    const isEdit = ref(false);
    const formData = reactive({
      id: null,
      name: '',
      status: 0,
      level: 0,
      leader: '',
      // 负责人
      phone: '',
      // 联系方式
      majorRegion: '',
      minorRegion: '',
      // 省市区字符串，格式：省/市/区
      address: '',
      joinDate: '',
      expireDate: '',
      deposit: 0,
      remark: ''
    });

    // 详情弹窗
    const showDetailModal = ref(false);
    const detailInitialTab = ref('basic');
    const showPlatformReceiverModal = ref(false);

    // 产品授权相关
    const authorizedProducts = ref([]); // 选中的授权产品ID列表
    const showProductSelector = ref(false); // 是否显示产品选择器
    const productTree = ref([]); // 产品树数据
    const productTreeLoading = ref(false); // 产品树加载状态

    // 状态文本映射
    const statusTextMap = {
      0: '潜在加盟商',
      1: '意向加盟商',
      2: '签约审核中',
      3: '正式加盟商',
      4: '暂停',
      5: '终止'
    };

    // 等级文本映射
    const levelTextMap = {
      0: '普通加盟商',
      1: '银牌加盟商',
      2: '金牌加盟商',
      3: '钻石加盟商'
    };

    // 获取状态文本
    const getStatusText = status => {
      return statusTextMap[status] || '未知';
    };

    // 获取等级文本
    const getLevelText = level => {
      return levelTextMap[level] || '未知';
    };

    // 获取状态样式
    const getStatusClass = status => {
      const classes = {
        0: 'status-badge is-neutral',
        1: 'status-badge is-info',
        2: 'status-badge is-warning',
        3: 'status-badge is-success',
        4: 'status-badge is-danger',
        5: 'status-badge is-neutral'
      };
      return classes[status] || 'status-badge is-neutral';
    };

    // 获取等级样式
    const getLevelClass = level => {
      const classes = {
        0: 'status-badge is-neutral',
        1: 'bg-slate-200 text-slate-700',
        2: 'status-badge is-warning',
        3: 'status-badge is-purple'
      };
      return classes[level] || 'status-badge is-neutral';
    };

    // 加载加盟商列表
    const fetchFranchisees = async () => {
      loading.value = true;
      try {
        const params = {
          name: searchForm.name || undefined,
          statuses: searchForm.statuses?.length ? searchForm.statuses : undefined,
          levels: searchForm.levels?.length ? searchForm.levels : undefined,
          majorRegion: searchForm.majorRegion || undefined,
          needPerformance: true,
          current: pagination.current,
          size: pagination.size
        };
        const res = await getFranchiseePage(params);
        franchisees.value = res.records || [];
        pagination.total = res.total || 0;
        pagination.pages = res.pages || 0;
        pagination.hasNext = res.hasNext || false;
        pagination.hasPrevious = res.hasPrevious || false;

        // 更新统计
        stats.total = res.total || 0;
        // 暂时使用模拟数据更新统计
        stats.active = franchisees.value.filter(f => f.status === 3).length;
        stats.pending = franchisees.value.filter(f => f.status === 2).length;
        stats.suspended = franchisees.value.filter(f => f.status === 4).length;
      } catch (error) {
        console.error('获取加盟商列表失败:', error);
        ElMessage.error('获取加盟商列表失败');
      } finally {
        loading.value = false;
      }
    };

    // 搜索
    const handleSearch = () => {
      pagination.current = 1;
      fetchFranchisees();
    };

    // 重置
    const handleReset = () => {
      searchForm.name = '';
      searchForm.statuses = [];
      searchForm.levels = [];
      searchForm.majorRegion = '';
      pagination.current = 1;
      fetchFranchisees();
    };

    // 分页切换
    const handlePageChange = page => {
      const totalPages = Math.max(1, Math.ceil(pagination.total / pagination.size));
      if (page < 1 || page > totalPages) return;
      pagination.current = page;
      fetchFranchisees();
    };
    const handlePageSizeChange = size => {
      pagination.size = size;
      pagination.current = 1;
      fetchFranchisees();
    };

    // 加载产品树
    const loadProductTree = async () => {
      productTreeLoading.value = true;
      try {
        const res = await getProductTree(0);
        productTree.value = res || [];
      } catch (error) {
        console.error('加载产品树失败:', error);
        productTree.value = [];
      } finally {
        productTreeLoading.value = false;
      }
    };

    // 打开产品选择器
    const openProductSelector = async () => {
      if (productTree.value.length === 0) {
        await loadProductTree();
      }
      showProductSelector.value = true;
    };

    // 打开新建弹窗
    const openCreateModal = () => {
      isEdit.value = false;
      Object.assign(formData, {
        id: null,
        name: '',
        status: 0,
        level: 0,
        leader: '',
        phone: '',
        majorRegion: '',
        minorRegion: '',
        address: '',
        joinDate: '',
        expireDate: '',
        deposit: 0,
        remark: ''
      });
      areaCodes.value = [];
      authorizedProducts.value = []; // 重置产品选择
      showFormModal.value = true;
    };

    // 打开编辑弹窗
    const openEditModal = async franchisee => {
      isEdit.value = true;
      try {
        const res = await getFranchisee(franchisee.id);
        // 从 minorRegion 解析，设置 areaCodes
        if (res.minorRegion) {
          const parts = res.minorRegion.split('/');
          // 查找对应的code
          const findCode = (name, parentCode = '86') => {
            const parentData = parentCode === '86' ? provinceData : chinaAreaData[parentCode];
            for (const [code, n] of Object.entries(parentData || {})) {
              if (n === name) return code;
            }
            return null;
          };
          const provinceCode = findCode(parts[0]);
          const cityCode = provinceCode ? findCode(parts[1], provinceCode) : null;
          const districtCode = cityCode ? findCode(parts[2], cityCode) : null;
          areaCodes.value = [provinceCode, cityCode, districtCode].filter(Boolean);
        } else {
          areaCodes.value = [];
        }
        Object.assign(formData, {
          id: res.id,
          name: res.name || '',
          status: res.status ?? 0,
          level: res.level ?? 0,
          leader: res.leader || '',
          phone: res.phone || '',
          majorRegion: res.majorRegion || '',
          minorRegion: res.minorRegion || '',
          address: res.address || '',
          joinDate: res.joinDate || '',
          expireDate: res.expireDate || '',
          deposit: res.deposit || 0,
          remark: res.remark || ''
        });
        showFormModal.value = true;
      } catch (error) {
        console.error('获取加盟商详情失败:', error);
        ElMessage.error('获取加盟商详情失败');
      }
    };

    // 关闭表单弹窗
    const closeFormModal = () => {
      showFormModal.value = false;
    };

    // 省市区选择变化
    const areaCodes = ref([]); // 临时存储选择的code
    const areaCascaderRef = ref(null);
    const handleAreaChange = value => {
      if (value && value.length >= 3) {
        const province = provinceData[value[0]] || ''; // 省份从 provinceData 获取
        const city = CodeToText[value[1]] || ''; // 城市从 CodeToText 获取
        const district = CodeToText[value[2]] || ''; // 区县从 CodeToText 获取
        formData.minorRegion = `${province}/${city}/${district}`;
        closeChinaAreaCascaderAfterDistrict(areaCascaderRef.value, value);
      } else {
        formData.minorRegion = '';
        areaCodes.value = [];
      }
    };

    // 提交表单
    const handleSubmit = async () => {
      if (!formData.name.trim()) {
        ElMessage.warning('请输入加盟商名称');
        return;
      }
      if (!formData.majorRegion) {
        ElMessage.warning('请选择大区域');
        return;
      }
      submitting.value = true;
      try {
        // 构建提交数据，添加授权产品ID列表
        const submitData = {
          ...formData,
          // 新建时传递授权产品ID列表，为空则初始化全部产品
          productIds: authorizedProducts.value.length > 0 ? authorizedProducts.value : undefined
        };
        if (isEdit.value) {
          await updateFranchisee(submitData);
          ElMessage.success('更新成功');
        } else {
          await createFranchisee(submitData);
          ElMessage.success('创建成功');
        }
        closeFormModal();
        fetchFranchisees();
      } catch (error) {
        console.error('保存失败:', error);
        ElMessage.error(error.message || '保存失败');
      } finally {
        submitting.value = false;
      }
    };

    // 删除加盟商
    const handleDelete = async franchisee => {
      try {
        await ElMessageBox.confirm(`确定要删除加盟商 "${franchisee.name}" 吗？此操作不可恢复。`, '删除确认', {
          type: 'warning'
        });
        await deleteFranchisee(franchisee.id);
        ElMessage.success('删除成功');
        fetchFranchisees();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          ElMessage.error('删除失败');
        }
      }
    };

    // 审核通过
    const handleApprove = async franchisee => {
      try {
        await ElMessageBox.confirm(`确定要通过加盟商 "${franchisee.name}" 的审核吗？`, '审核确认', {
          type: 'info'
        });
        await changeFranchiseeStatus({
          id: franchisee.id,
          toStatus: 3,
          // 正式加盟商
          reason: '审核通过'
        });
        ElMessage.success('审核已通过');
        fetchFranchisees();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('审核失败:', error);
          ElMessage.error('审核失败');
        }
      }
    };

    // 打开详情弹窗
    const openDetailModal = (franchisee, initialTab = 'basic') => {
      selectedFranchisee.value = franchisee;
      detailInitialTab.value = initialTab;
      showDetailModal.value = true;
    };
    const openAccountDetailModal = franchisee => {
      openDetailModal(franchisee, 'bank');
    };
    const openPlatformReceiverFromDetail = () => {
      if (!selectedFranchisee.value) return;
      showPlatformReceiverModal.value = true;
    };
    const handlePlatformReceiverSuccess = () => {
      fetchFranchisees();
      detailInitialTab.value = 'bank';
    };

    // 初始化
    onMounted(() => {
      fetchFranchisees();
    });
    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "加盟商管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理加盟商信息，包括资质审核、区域管理、业绩考核等")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[21] || (_cache[21] = _createElementVNode("div", {
          class: "flex items-center justify-between mb-2"
        }, [_createElementVNode("div", {
          class: "w-9 h-9 bg-gradient-to-br from-primary-100 to-primary-50 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
        })])]), _createElementVNode("span", {
          class: "status-badge bg-primary-50 text-primary-600"
        }, "总计")], -1)), _createElementVNode("div", _hoisted_3, _toDisplayString(stats.total), 1), _cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "text-sm text-slate-500"
        }, "全部加盟商", -1))]), _createElementVNode("div", _hoisted_4, [_cache[23] || (_cache[23] = _createElementVNode("div", {
          class: "flex items-center justify-between mb-2"
        }, [_createElementVNode("div", {
          class: "w-9 h-9 bg-gradient-to-br from-green-100 to-green-50 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-green-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        })])]), _createElementVNode("span", {
          class: "status-badge is-success"
        }, "活跃")], -1)), _createElementVNode("div", _hoisted_5, _toDisplayString(stats.active), 1), _cache[24] || (_cache[24] = _createElementVNode("div", {
          class: "text-sm text-slate-500"
        }, "正式加盟商", -1))]), _createElementVNode("div", _hoisted_6, [_cache[25] || (_cache[25] = _createElementVNode("div", {
          class: "flex items-center justify-between mb-2"
        }, [_createElementVNode("div", {
          class: "w-9 h-9 bg-gradient-to-br from-amber-100 to-amber-50 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-amber-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        })])]), _createElementVNode("span", {
          class: "status-badge is-warning"
        }, "待处理")], -1)), _createElementVNode("div", _hoisted_7, _toDisplayString(stats.pending), 1), _cache[26] || (_cache[26] = _createElementVNode("div", {
          class: "text-sm text-slate-500"
        }, "待审核加盟商", -1))]), _createElementVNode("div", _hoisted_8, [_cache[27] || (_cache[27] = _createElementVNode("div", {
          class: "flex items-center justify-between mb-2"
        }, [_createElementVNode("div", {
          class: "w-9 h-9 bg-gradient-to-br from-red-100 to-red-50 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-red-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
        })])]), _createElementVNode("span", {
          class: "status-badge is-danger"
        }, "非活跃")], -1)), _createElementVNode("div", _hoisted_9, _toDisplayString(stats.suspended), 1), _cache[28] || (_cache[28] = _createElementVNode("div", {
          class: "text-sm text-slate-500"
        }, "已暂停加盟商", -1))])]), _createElementVNode("div", _hoisted_10, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchFranchisees
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: openCreateModal,
            class: "btn-primary"
          }, [...(_cache[30] || (_cache[30] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新建加盟商 ", -1)]))])), [[_directive_permission, 'franchisee:add']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            onClick: handleSearch,
            class: "btn-primary"
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            onClick: handleReset,
            class: "btn-secondary"
          }, "重置")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchForm.name = $event),
            type: "text",
            placeholder: "搜索加盟商名称、编号...",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, searchForm.name]]), _cache[29] || (_cache[29] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createElementVNode("div", _hoisted_12, [_createVNode(_unref(ElSelect), {
            modelValue: searchForm.statuses,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.statuses = $event),
            multiple: "",
            "collapse-tags": "",
            placeholder: "状态",
            clearable: "",
            class: "w-full form-select form-control-sm"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, s => {
              return _createVNode(_unref(ElOption), {
                key: s.value,
                label: s.label,
                value: s.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_13, [_createVNode(_unref(ElSelect), {
            modelValue: searchForm.levels,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchForm.levels = $event),
            multiple: "",
            "collapse-tags": "",
            placeholder: "等级",
            clearable: "",
            class: "w-full form-select form-control-sm"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElOption), {
              value: 0,
              label: "普通"
            }), _createVNode(_unref(ElOption), {
              value: 1,
              label: "银牌"
            }), _createVNode(_unref(ElOption), {
              value: 2,
              label: "金牌"
            }), _createVNode(_unref(ElOption), {
              value: 3,
              label: "钻石"
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_14, [_createVNode(_unref(ElSelect), {
            modelValue: searchForm.majorRegion,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => searchForm.majorRegion = $event),
            placeholder: "区域",
            clearable: "",
            class: "w-full form-select form-control-sm"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(regions, region => {
              return _createVNode(_unref(ElOption), {
                key: region,
                label: region,
                value: region
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("table", _hoisted_17, [_cache[39] || (_cache[39] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "加盟商信息"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "经营区域"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "负责人"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "等级"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "订单数"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "业绩金额"), _createElementVNode("th", {
          class: "data-table-th text-center"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[31] || (_cache[31] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-3"
          }, [_createElementVNode("div", {
            class: "w-8 h-8 bg-slate-200 rounded-xl"
          }), _createElementVNode("div", null, [_createElementVNode("div", {
            class: "h-4 w-32 bg-slate-200 rounded mb-1"
          }), _createElementVNode("div", {
            class: "h-3 w-24 bg-slate-200 rounded"
          })])])], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-20 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-16 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-5 w-12 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-right"
          }, [_createElementVNode("div", {
            class: "h-4 w-12 bg-slate-200 rounded ml-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-right"
          }, [_createElementVNode("div", {
            class: "h-4 w-20 bg-slate-200 rounded ml-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-6 w-14 bg-slate-200 rounded-full mx-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "flex items-center justify-center gap-1"
          }, [_createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          })])], -1)]))]);
        }), 64)) : _createCommentVNode("", true), !loading.value && franchisees.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [...(_cache[32] || (_cache[32] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, "暂无加盟商数据", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(franchisees.value, franchisee => {
          return _openBlock(), _createElementBlock("tr", {
            key: franchisee.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_cache[33] || (_cache[33] = _createElementVNode("div", {
            class: "w-8 h-8 bg-gradient-to-br from-primary-100 to-primary-50 rounded-xl flex items-center justify-center"
          }, [_createElementVNode("svg", {
            class: "w-6 h-6 text-primary-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          })])], -1)), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_21, _toDisplayString(franchisee.name), 1), _createElementVNode("div", _hoisted_22, [_createElementVNode("span", null, _toDisplayString(franchisee.franchiseeNo || '-'), 1), franchisee.joinDate ? (_openBlock(), _createElementBlock("span", _hoisted_23, "|")) : _createCommentVNode("", true), franchisee.joinDate ? (_openBlock(), _createElementBlock("span", _hoisted_24, "加盟: " + _toDisplayString(franchisee.joinDate), 1)) : _createCommentVNode("", true)])])])]), _createElementVNode("td", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(franchisee.majorRegion || '-'), 1), franchisee.minorRegion ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(franchisee.minorRegion), 1)) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(franchisee.leader || '-'), 1), franchisee.phone ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(franchisee.phone), 1)) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_33, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', getLevelClass(franchisee.level)])
          }, _toDisplayString(franchisee.levelDesc || getLevelText(franchisee.level)), 3)]), _createElementVNode("td", _hoisted_34, _toDisplayString(franchisee.orderCount || 0), 1), _createElementVNode("td", _hoisted_35, "¥" + _toDisplayString((franchisee.performanceAmount || 0).toLocaleString()), 1), _createElementVNode("td", _hoisted_36, [_createElementVNode("span", {
            class: _normalizeClass(['px-3 py-1.5 rounded-full text-xs font-semibold', getStatusClass(franchisee.status)])
          }, _toDisplayString(franchisee.statusDesc || getStatusText(franchisee.status)), 3)]), _createElementVNode("td", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("button", {
            onClick: $event => openDetailModal(franchisee),
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情"
          }, [...(_cache[34] || (_cache[34] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_39), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => openAccountDetailModal(franchisee),
            class: "table-action-button is-teal",
            title: "分账账户",
            "aria-label": "分账账户"
          }, [...(_cache[35] || (_cache[35] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
          })], -1)]))], 8, _hoisted_40)), [[_directive_permission, 'franchisee:account:query']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => openEditModal(franchisee),
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑"
          }, [...(_cache[36] || (_cache[36] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_41)), [[_directive_permission, 'franchisee:edit']]), franchisee.status === 2 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => handleApprove(franchisee),
            class: "table-action-button is-teal",
            title: "审核通过",
            "aria-label": "审核通过"
          }, [...(_cache[37] || (_cache[37] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)]))], 8, _hoisted_42)), [[_directive_permission, 'franchisee:edit']]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleDelete(franchisee),
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除"
          }, [...(_cache[38] || (_cache[38] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_43)), [[_directive_permission, 'franchisee:delete']])])])]);
        }), 128))])])])]), !loading.value && franchisees.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_cache[41] || (_cache[41] = _createElementVNode("div", {
          class: "w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-5"
        }, [_createElementVNode("svg", {
          class: "w-10 h-10 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
        })])], -1)), _cache[42] || (_cache[42] = _createElementVNode("h3", {
          class: "empty-state-title"
        }, "暂无加盟商数据", -1)), _cache[43] || (_cache[43] = _createElementVNode("p", {
          class: "text-slate-500 mb-6"
        }, "点击下方按钮开始添加第一个加盟商吧", -1)), _createElementVNode("button", {
          onClick: openCreateModal,
          class: "flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-primary-600 to-primary-500 text-white rounded-lg hover:from-primary-700 hover:to-primary-600 shadow-lg shadow-primary-500/25 mx-auto transition-all duration-200 font-medium"
        }, [...(_cache[40] || (_cache[40] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 新建加盟商 ", -1)]))])])) : _createCommentVNode("", true), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 1,
          class: "pagination-bridge",
          pagination: pagination,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)]), _createVNode(_Transition, {
          name: "modal-fade"
        }, {
          default: _withCtx(() => [_createVNode(AppModal, {
            visible: showFormModal.value,
            size: "4xl",
            onClose: closeFormModal
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_cache[44] || (_cache[44] = _createElementVNode("div", {
              class: "w-10 h-10 bg-gradient-to-br from-primary-100 to-primary-50 rounded-xl flex items-center justify-center"
            }, [_createElementVNode("svg", {
              class: "w-6 h-6 text-primary-600",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            })])], -1)), _createElementVNode("div", null, [_createElementVNode("h3", _hoisted_47, _toDisplayString(isEdit.value ? '编辑加盟商' : '新建加盟商'), 1), _createElementVNode("p", _hoisted_48, _toDisplayString(isEdit.value ? '修改加盟商信息' : '填写加盟商基本信息'), 1)])]), _createElementVNode("button", {
              onClick: closeFormModal,
              class: "p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-all duration-200"
            }, [...(_cache[45] || (_cache[45] = [_createElementVNode("svg", {
              class: "w-6 h-6",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))])]), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_cache[46] || (_cache[46] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, [_createTextVNode(" 加盟商名称 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.name = $event),
              type: "text",
              class: "form-input",
              placeholder: "请输入加盟商名称"
            }, null, 512), [[_vModelText, formData.name]])]), _createElementVNode("div", _hoisted_52, [_cache[47] || (_cache[47] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, [_createTextVNode(" 大区域 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _createVNode(_unref(ElSelect), {
              modelValue: formData.majorRegion,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.majorRegion = $event),
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElOption), {
                label: "请选择区域",
                value: ""
              }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(regions, region => {
                return _createVNode(_unref(ElOption), {
                  key: region,
                  label: region,
                  value: region
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_53, [_cache[48] || (_cache[48] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "省市区", -1)), _createVNode(_unref(ElCascader), {
              ref_key: "areaCascaderRef",
              ref: areaCascaderRef,
              modelValue: areaCodes.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => areaCodes.value = $event),
              options: regionTree.value,
              placeholder: "请选择省市区",
              filterable: "",
              clearable: "",
              class: "w-full",
              onChange: handleAreaChange
            }, null, 8, ["modelValue", "options"])]), _createElementVNode("div", _hoisted_54, [_cache[49] || (_cache[49] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "详细地址", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.address = $event),
              type: "text",
              class: "form-input",
              placeholder: "请输入详细地址"
            }, null, 512), [[_vModelText, formData.address]])]), _createElementVNode("div", _hoisted_55, [_cache[50] || (_cache[50] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "加盟等级", -1)), _createVNode(_unref(ElSelect), {
              modelValue: formData.level,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.level = $event),
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElOption), {
                label: "普通加盟商",
                value: 0
              }), _createVNode(_unref(ElOption), {
                label: "银牌加盟商",
                value: 1
              }), _createVNode(_unref(ElOption), {
                label: "金牌加盟商",
                value: 2
              }), _createVNode(_unref(ElOption), {
                label: "钻石加盟商",
                value: 3
              })]),
              _: 1
            }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_56, [_cache[51] || (_cache[51] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "负责人", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formData.leader = $event),
              type: "text",
              class: "form-input",
              placeholder: "请输入负责人姓名"
            }, null, 512), [[_vModelText, formData.leader]])]), _createElementVNode("div", _hoisted_57, [_cache[52] || (_cache[52] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "联系方式", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => formData.phone = $event),
              type: "text",
              class: "form-input",
              placeholder: "请输入联系方式"
            }, null, 512), [[_vModelText, formData.phone]])]), _createElementVNode("div", _hoisted_58, [_cache[53] || (_cache[53] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "加盟日期", -1)), _createVNode(_component_el_date_picker, {
              modelValue: formData.joinDate,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => formData.joinDate = $event),
              type: "date",
              class: "form-date",
              format: "YYYY年MM月DD日",
              "value-format": "YYYY-MM-DD",
              placeholder: "请选择加盟日期"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_59, [_cache[54] || (_cache[54] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "到期日期", -1)), _createVNode(_component_el_date_picker, {
              modelValue: formData.expireDate,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => formData.expireDate = $event),
              type: "date",
              class: "form-date",
              format: "YYYY年MM月DD日",
              "value-format": "YYYY-MM-DD",
              placeholder: "请选择到期日期"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_60, [_cache[55] || (_cache[55] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "保证金 (¥)", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formData.deposit = $event),
              type: "number",
              class: "form-input",
              placeholder: "请输入保证金金额"
            }, null, 512), [[_vModelText, formData.deposit, void 0, {
              number: true
            }]])]), _createElementVNode("div", _hoisted_61, [_cache[56] || (_cache[56] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "状态", -1)), _createVNode(_unref(ElSelect), {
              modelValue: formData.status,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => formData.status = $event),
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElOption), {
                label: "潜在加盟商",
                value: 0
              }), _createVNode(_unref(ElOption), {
                label: "意向加盟商",
                value: 1
              }), _createVNode(_unref(ElOption), {
                label: "签约审核中",
                value: 2
              }), _createVNode(_unref(ElOption), {
                label: "正式加盟商",
                value: 3
              }), _createVNode(_unref(ElOption), {
                label: "暂停",
                value: 4
              }), _createVNode(_unref(ElOption), {
                label: "终止",
                value: 5
              })]),
              _: 1
            }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_62, [_cache[57] || (_cache[57] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "备注信息", -1)), _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => formData.remark = $event),
              rows: "3",
              class: "form-textarea",
              placeholder: "请输入备注信息"
            }, null, 512), [[_vModelText, formData.remark]])]), _createElementVNode("div", _hoisted_63, [_cache[60] || (_cache[60] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, [_createTextVNode(" 授权产品 "), _createElementVNode("span", {
              class: "text-xs font-normal text-slate-400 ml-2"
            }, "选择授权给该加盟商的产品（留空则授权全部产品）")], -1)), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("span", _hoisted_66, [_cache[58] || (_cache[58] = _createTextVNode("已选择 ", -1)), _createElementVNode("span", _hoisted_67, _toDisplayString(authorizedProducts.value.length), 1), _cache[59] || (_cache[59] = _createTextVNode(" 个产品", -1))]), _createElementVNode("button", {
              onClick: openProductSelector,
              type: "button",
              class: "text-sm text-primary-600 hover:text-primary-700 font-medium"
            }, " 选择产品 ")]), authorizedProducts.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_68, [_createElementVNode("span", _hoisted_69, _toDisplayString(authorizedProducts.value.length) + " 个产品已授权 ", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_70, " 暂未选择产品，将授权全部产品给该加盟商 "))])])])]), _createElementVNode("div", _hoisted_71, [_createElementVNode("button", {
              type: "button",
              onClick: closeFormModal,
              class: "btn-secondary"
            }, " 取消 "), _createElementVNode("button", {
              type: "button",
              onClick: handleSubmit,
              disabled: submitting.value,
              class: "btn-primary"
            }, [submitting.value ? (_openBlock(), _createElementBlock("svg", _hoisted_73, [...(_cache[61] || (_cache[61] = [_createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }, null, -1), _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_74, [...(_cache[62] || (_cache[62] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M5 13l4 4L19 7"
            }, null, -1)]))])), _createTextVNode(" " + _toDisplayString(isEdit.value ? '保存修改' : '创建加盟商'), 1)], 8, _hoisted_72)])]),
            _: 1
          }, 8, ["visible"])]),
          _: 1
        }), _createVNode(FranchiseeDetailModal, {
          visible: showDetailModal.value,
          "onUpdate:visible": _cache[16] || (_cache[16] = $event => showDetailModal.value = $event),
          "franchisee-id": selectedFranchisee.value?.id,
          "franchisee-info": selectedFranchisee.value,
          "initial-tab": detailInitialTab.value,
          onOpenPlatformReceiver: openPlatformReceiverFromDetail
        }, null, 8, ["visible", "franchisee-id", "franchisee-info", "initial-tab"]), _createVNode(PlatformLakalaReceiverFormModal, {
          visible: showPlatformReceiverModal.value,
          "onUpdate:visible": _cache[17] || (_cache[17] = $event => showPlatformReceiverModal.value = $event),
          "franchisee-id": selectedFranchisee.value?.id,
          "franchisee-info": selectedFranchisee.value,
          onSuccess: handlePlatformReceiverSuccess
        }, null, 8, ["visible", "franchisee-id", "franchisee-info"]), _createVNode(ProductSelector, {
          visible: showProductSelector.value,
          "onUpdate:visible": _cache[18] || (_cache[18] = $event => showProductSelector.value = $event),
          modelValue: authorizedProducts.value,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => authorizedProducts.value = $event),
          "product-tree": productTree.value,
          title: "选择授权产品",
          description: "选择要授权给该加盟商的产品"
        }, null, 8, ["visible", "modelValue", "product-tree"])]),
        _: 1
      });
    };
  }
};